enum ProjectMessageType {
  CONTRACT_VERIFICATION_FAILED = 'CONTRACT_VERIFICATION_FAILED',
  CONTRACT_VERIFICATION_SUCCESS = 'CONTRACT_VERIFICATION_SUCCESS',
  CONTRACT_DEPLOYMENT_FAILED = 'CONTRACT_DEPLOYMENT_FAILED',
  CONTRACT_DEPLOYMENT_SUCCESS = 'CONTRACT_DEPLOYMENT_SUCCESS',
}

export default ProjectMessageType;
